<form #clearedCheckLayoutForm="ngForm" (ngSubmit)="clearedCheckLayoutForm.valid && save()" *ngIf="bankId > 0"
	[duplicateValueValidator]="['fieldColumn-']" clearedCheckLayoutFieldsValidator>
	<div class="row">
		<div class="col-xs-12">
			<div class="panel panel-default">
				<div class="panel-body paddingSmall">
					<div class="row">
						<div class="col-xs-12">
							<span class="bold">Cleared Check File Layout</span>
						</div>
					</div>
				</div>
				<div class="panel-footer">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label for="delimitedFile">File Type</label>
								<mat-radio-group name="delimitedFile" aria-label="Select a File Type" [(ngModel)]="fileType" class="bs-radio-group"
									[disabled]="isReadOnly">
									<mat-radio-button [value]="'FIXED'">Fixed</mat-radio-button>
									<mat-radio-button [value]="'DELIMITED'">Delimited</mat-radio-button>
									<mat-radio-button [value]="'NCBANK'" [disabled]="!isNcUnit">NC State Bank</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
						<div class="col-md-6 col-lg-3" *ngIf="fileType === 'DELIMITED'">
							<div class="form-group">
								<label for="delimiter">Delimiter</label>
								<select name="delimiter" #delimiter="ngModel" class="form-control" [(ngModel)]="clearedCheckLayout.Delimiter" required
									[disabled]="isReadOnly">
									<option></option>
									<option value=",">Comma</option>
									<option value="TAB">Tab</option>
									<option value="|">Pipe</option>
								</select>
								<mat-error *ngIf="delimiter.errors?.required">Delimiter is required</mat-error>
							</div>
						</div>
					</div>
					<div *ngIf="fileType && fileType !== 'NCBANK'">
						<div class="alert alert-info">
							Indicate the positions where the following fields are found in the cleared check file
						</div>
						<div class="row">
							<div class="col-xs-12 col-lg-offset-2 col-lg-8">
								<table class="table" aria-label="Field Positions">
									<thead>
										<tr>
											<th style="width: 80px;"></th>
											<th *ngIf="!clearedCheckLayout.DelimitedFile">Start Position</th>
											<th *ngIf="!clearedCheckLayout.DelimitedFile">Length</th>
											<th *ngIf="clearedCheckLayout.DelimitedFile">Column #</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let field of clearedCheckLayout.ClearedCheckLayoutFields; index as index; trackById">
											<td>{{ field.FieldName }}</td>
											<td *ngIf="!clearedCheckLayout.DelimitedFile">
												<input class="form-control" [name]="'fieldStart-' + index" #fieldStart="ngModel"
													[(ngModel)]="field.FieldStart" inputmode="numeric" required maxlength="2" pattern="[0-9]*"
													numbersOnly [allowDecimals]="false" [disabled]="isReadOnly" />
												<mat-error *ngIf="fieldStart.errors?.required">Start Position is required</mat-error>
											</td>
											<td *ngIf="!clearedCheckLayout.DelimitedFile">
												<input class="form-control" [name]="'fieldLength-' + index" #fieldLength="ngModel"
													[(ngModel)]="field.FieldLength" inputmode="numeric" required maxlength="2" pattern="[0-9]*"
													numbersOnly [allowDecimals]="false" [disabled]="isReadOnly" />
												<mat-error *ngIf="fieldLength.errors?.required">Length is required</mat-error>
											</td>
											<td *ngIf="clearedCheckLayout.DelimitedFile">
												<input class="form-control" [name]="'fieldColumn-' + index" #fieldColumn="ngModel"
													[(ngModel)]="field.FieldColumn" placeholder="Enter 1 for the first column" inputmode="numeric"
													required maxlength="2" pattern="[0-9]*" numbersOnly [allowDecimals]="false"
													[disabled]="isReadOnly" />
												<mat-error *ngIf="fieldColumn.errors?.required">Column # is required</mat-error>
												<mat-error *ngIf="fieldColumn.errors?.duplicateValue">Duplicate column number</mat-error>
											</td>
										</tr>
										<tr *ngIf="clearedCheckLayoutForm.errors?.fieldsOverlapping">
											<td colspan="3">
												<mat-error>Field overlapping is not allowed</mat-error>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="row tabButtonGroup" *ngIf="clearedCheckLayoutForm.dirty">
						<div class="col-xs-4">
							<button class="btn btn-cancelSave" (click)="cancelSave()">CANCEL</button>
						</div>
						<div class="col-xs-4 pull-right">
							<button class="btn btn-save" type="submit" [disabled]="clearedCheckLayoutForm.invalid">SAVE</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>
